(() => {
  const widget = document.querySelector('[data-rhsb-whatsapp]');
  if (!widget) return;
  const link = widget.querySelector('a');
  const phone = widget.dataset.phone;
  const variantSelect = document.querySelector('[data-product-variant]');
  const cleanPageUrl = () => {
    const url = new URL(window.location.href);
    ['preview_theme_id', '_fd', 'pb', 'section_id'].forEach((key) => url.searchParams.delete(key));
    url.hash = '';
    return url;
  };
  const selectedVariant = () => {
    const option = variantSelect?.selectedOptions?.[0];
    if (option) return {id: option.value, title: option.dataset.variantTitle || '', sku: option.dataset.sku || ''};
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]:checked, form[action*="/cart/add"] input[name="id"]');
    return input ? {id: input.value, title: input.dataset.variantTitle || '', sku: input.dataset.sku || ''} : null;
  };
  const buildMessage = () => {
    const url = cleanPageUrl();
    const title = widget.dataset.productTitle;
    if (!title) return `Hi RHSB, I need some assistance.\n\nPage: ${url.href}`;
    const variant = selectedVariant();
    if (variant?.id) url.searchParams.set('variant', variant.id);
    const lines = ['Hi RHSB, I would like to ask about this product:', '', `Product: ${title}`];
    if (variant?.title && variant.title !== 'Default Title') lines.push(`Variant: ${variant.title}`);
    if (variant?.sku) lines.push(`SKU: ${variant.sku}`);
    lines.push(`Link: ${url.href}`, '', 'My question:');
    return lines.join('\n');
  };
  const updateLink = () => { link.href = `https://wa.me/${phone}?text=${encodeURIComponent(buildMessage())}`; };
  updateLink();
  variantSelect?.addEventListener('change', updateLink);
  link.addEventListener('pointerenter', updateLink);
  link.addEventListener('focus', updateLink);
  link.addEventListener('touchstart', updateLink, {passive: true});
  link.addEventListener('click', updateLink);
  const isVisible = (node) => {
    if (!node || !node.getClientRects().length) return false;
    const style = getComputedStyle(node);
    return style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) !== 0;
  };
  const intersects = (a, b) => a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  let scheduled = false;
  const checkObstructions = () => {
    scheduled = false;
    widget.dataset.obstructed = 'false';
    const bounds = widget.getBoundingClientRect();
    const critical = document.querySelectorAll('.product-add, [name="checkout"], [data-cart-drawer], .cart-drawer, dialog[open], [role="dialog"][aria-modal="true"], .shopify-pc__banner__dialog, [class*="cookie-banner"]');
    widget.dataset.obstructed = Array.from(critical).some((node) => isVisible(node) && intersects(bounds, node.getBoundingClientRect())) ? 'true' : 'false';
  };
  const scheduleCheck = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(checkObstructions); } };
  window.addEventListener('scroll', scheduleCheck, {passive: true});
  window.addEventListener('resize', scheduleCheck);
  document.addEventListener('click', scheduleCheck);
  scheduleCheck();
})();
